import React from "react";
import { shallowEqual } from "react-redux";
import StandardFinancePackContent from "./StandardFinancePackContent";
import OptionalFinancePackContent from "./OptionalFinancePackContent";
import type { PackType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useBnbSelector } from "../../../redux/store";
import { getFinancePackContent } from "../../../../../shared-logic/utils/packUtils";
import * as Styles from "./styles/FinancePackEquipmentTable";
import { getSelectedFinancePackEquipmentSelector } from "../../../utils/selectorUtils";

type FinancePackEquipmentTablePropType = {
    pack: PackType;
    onlyShowSelected?: boolean; // Used for showing only selected packs on summary
};

const FinancePackContent = (props: FinancePackEquipmentTablePropType): JSX.Element => {
    const { pack, onlyShowSelected } = props;
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const items = useBnbSelector((state) => state.items);

    const basketEquipment = useBnbSelector(getSelectedFinancePackEquipmentSelector(pack), shallowEqual);

    const standardContent =
        onlyShowSelected && financeOption === "cash"
            ? basketEquipment.standard
            : getFinancePackContent(pack, true, financeOption, items);
    const optionalContent = onlyShowSelected
        ? basketEquipment.optional
        : getFinancePackContent(pack, false, financeOption, items);

    return (
        <Styles.Wrapper>
            <div>
                {standardContent &&
                    standardContent.map((content) => (
                        <StandardFinancePackContent key={content.id} equipment={content} pack={pack} />
                    ))}
            </div>
            <div>
                {optionalContent &&
                    optionalContent.map((content) => (
                        <OptionalFinancePackContent key={content.id} equipment={content} pack={pack} />
                    ))}
            </div>
        </Styles.Wrapper>
    );
};

export default FinancePackContent;
